export function Monitoring() {
    return <h2>Monitoring Page</h2>;
}
